<template>
  <v-container fluid>
    <subHeader />
    <v-container fluid style="max-width: 1266px">
      <v-row>
        <div style="width: 1266px !important; padding-bottom: 1rem">
          <h2>
            The Fares Lounge
          </h2>
          <p style="margin-top: 15px;">
            <b>Join us for an in-depth session that will help you understand Air New Zealand fare sheets through some tips and insights.</b>
          </p>
          <br />
          <div style="background-color:white; margin-bottom:1.5vw; padding:1.5vw;" class="pl-12">
            <p>
              <b>What to expect: </b>
            </p>
                An interactive in person session on our Longhaul fares, including how best to use our fare sheets and understanding our longterm fares.
            <br/>
                An opportunity to go through examples with our Fares Desk Expert, Pat.
          </div>
          <div style="margin-bottom:1.5vw; padding-left:1.5vw; padding-right:1.5vw;" class="pl-12">
            <p>
              <b>Dates: </b>
            </p>
                The Fares Lounge training will run for three consecutive days for each city (AKL, WLG & CHC). There will be two sessions per day (morning & afternoon) so that’s a total of 18 sessions for all three cities - more dates and venues will be released soon.
          </div>

          <div style="background-color:white; margin-bottom:1.5vw; padding:1.5vw;" class="pl-12">
            <table class="custom-table">
              <tr>
                <td rowspan="3" class="city"><strong>Auckland</strong></td>
                <td>30th September 8am - 10am</td>
                <td>30th September 3pm - 5pm</td>
              </tr>
              <tr>
                <td>1st October 8am - 10am</td>
                <td>1st October 3pm - 5pm</td>
              </tr>
              <tr>
                <td>2nd October 8am - 10am</td>
                <td>2nd October 3pm - 5pm</td>
              </tr>

              <tr>
                <td rowspan="3" class="city"><strong>Wellington</strong></td>
                <td>14th October 8am - 10am</td>
                <td>14th October 3pm - 5pm</td>
              </tr>
              <tr>
                <td>15th October 8am - 10am</td>
                <td>15th October 3pm - 5pm</td>
              </tr>
              <tr>
                <td>16th October 8am - 10am</td>
                <td>16th October 3pm - 5pm</td>
              </tr>

              <tr>
                <td rowspan="3" class="city"><strong>Christchurch</strong></td>
                <td>4th November 8am - 10am</td>
                <td>4th November 3pm - 5pm</td>
              </tr>
              <tr>
                <td>5th November 8am - 10am</td>
                <td>5th November 3pm - 5pm</td>
              </tr>
              <tr>
                <td>6th November 8am - 10am</td>
                <td>6th November 3pm - 5pm</td>
              </tr>
            </table>

          </div>

          <div>
            <v-btn
              style="width: 243px; height: 50px; font-size: 16px"
              color="#00b0b9"
              class="mt-4 mr-4"
              :elevation="0"
              bottom
              dark
              @click="showSlotTimeDialog = true;"
              >Register Now</v-btn
            >
          </div>
          
        </div>
      </v-row>

      <v-dialog v-model="showSlotTimeDialog" persistent width="800px">
        <v-card class="white" height="100%" :style="{ borderRadius: '8px'}">
          <v-card-title class="pa-1 pl-6" :style="{ backgroundColor: '#00AFB9' }">
            <span class="notification-title-text-style">Choose Time Slot</span>
            <v-spacer></v-spacer>
            <v-btn icon x-large color="white" @click="showSlotTimeDialog = false"><v-icon>mdi-close</v-icon></v-btn>
          </v-card-title>
          <v-card-text class="pt-6">
            <v-row justify="center">
              <v-col class="d-flex justify-center">
                <v-btn-toggle
                  v-model="slotTime"
                  background-color="#00AFB9"
                  color="#00AFB9"
                  rounded="0"
                  tile
                  group
                  block
                  style="flex-direction:column;"
                >
                  <v-btn v-for="(value, index) in times" :key="index" :value="value">{{ value }}</v-btn>
                </v-btn-toggle>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="justify-center" :style="{ paddingBottom: '20px'}">
            <v-spacer></v-spacer>
            <v-btn height="45" width="120"
              style="font-size: 16px; background-color: #01b0b9 !important; color: white; text-transform: none !important;"
              @click="showSlotTimeDialog = false; submitSlot();">
              Submit
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </v-container>
</template>

<style scoped>
h2 {
  font-family: "AirNZ Sans Regular";
  font-size: 22px;
}
.custom-table {
  border-collapse: collapse;
  width: 100%;
}

.custom-table td {
  border: 1px solid #333;
  padding: 2px;
  vertical-align: middle;
}
.city {
  text-align: center;
  vertical-align: middle;
  width: 150px;
}
</style>

<script>
/* eslint-disable no-console */
import axios from "axios";
import subHeader from "./subHeader.vue";

export default {
  components: {
    subHeader,
  },
  data() {
    return {
      showSlotTimeDialog: false,
      slotTime: "",
      times: [],
      campaignName: 'Fare Lounge'
    };
  },
  mounted() {
    this.getTimeSlots();
  },
  methods: {
    getTimeSlots() {
      axios.
        post("/system/slot/times", {
                    campaignName: this.campaignName,
                })
        .then(response => {
          this.times = response.data;
        })
        .catch(error => {
          console.error("There was an error fetching time slots: ", error);
        });
    },
    submitSlot() {
            axios
        .post("/system/slot/save", {
                    slotTime: this.slotTime,
          campaignName: this.campaignName,
          campaignDate: "2025-08-01"
                })
                .then((response) => {
          var status = response.data.value ?? 'submitted'
                    // show notif
                    this.$store.commit("showNotification", 
                        {     
              title: "Awesome", 
                            content: "Thanks you’ve now " + status.toLowerCase() + " for the " + this.slotTime + " slot in the incentive.", 
                            color: "#00AFB9",
                            buttonText: "OK"
                        }
                    );
                });
        },
    },
};
</script>
